module.exports = __webpack_public_path__ + "img/index-qysl8.ace0508a.png";